import { z } from 'zod';
import { CustomFieldAssociationType, FormTrigger } from '../db/enums';
import { workspaceParamsSchema } from './workspace.payload';
import { formAssociationSchema } from '../form.types';

export const formCreationBodySchema = z.object({
    identifier: z.string(),
    title: z.string(),
    trigger: z.nativeEnum(FormTrigger),
    type: z.nativeEnum(CustomFieldAssociationType),
    customFields: z.array(
        z.object({
            uuid: z.string().uuid(),
            required: z.boolean().optional()
        })
    )
});

export type FormCreationBody = z.infer<typeof formCreationBodySchema>;

export const formUpdateBodySchema = z.object({
    title: z.string().optional(),
    trigger: z.nativeEnum(FormTrigger).optional(),
    customFields: z
        .array(
            z.object({
                uuid: z.string().uuid(),
                required: z.boolean().optional()
            })
        )
        .optional()
});

export type FormUpdateBody = z.infer<typeof formUpdateBodySchema>;

export const formParamsSchema = workspaceParamsSchema.extend({
    identifier: z.string()
});

export const formListQuerySchema = formAssociationSchema
    .optional()
    .refine(
        (v) => !v || !(v.folderUuid && v.projectUuid),
        'Only one project or folder UUID can be provided'
    );

export type FormListQuery = z.infer<typeof formListQuerySchema>;

export const formAssociationTargetSchema = formAssociationSchema
    .refine((v) => v.folderUuid || v.projectUuid, 'Either project or folder UUID must be provided')
    .refine((v) => !(v.folderUuid && v.projectUuid), 'Only one association target can be provided');

export type FormAssociationTarget = z.infer<typeof formAssociationTargetSchema>;
